import Instance from './interceptor';
import Toast from '../components/pages/utils/Toast';
import { API } from '../constants/Constants';
import { DOCUMENT_TOAST } from '../constants/toastConstant';

export const getTagData = async () => {
  try {
    const response = await Instance.get(`${API.GET_TAG_DATA}`);
    return response?.data?.tags;
  } catch (error) {
    Toast({
      message: `${error?.response?.data?.errorMessage}`,
      variant: 'error',
    });
    return error;
  }
};

export const createTag = async (newTag) => {
  try {
    const requestedTag = {
      tag: newTag,
    };
    const response = await Instance.post(`${API.ADD_TAG_DATA}`, requestedTag);
    if (response) {
      Toast({ message: DOCUMENT_TOAST.TAG_CREATED, variant: 'success' });
    }
    return response;
  } catch (error) {
    Toast({ message: `${error?.message}`, variant: 'error' });
    return error;
  }
};

export const addTagToDocument = async (id, tag) => {
  try {
    return await Instance.patch(`${API.ADD_TAG_TO_DOCUMENT}+'${id}'`, { tag });
  } catch (error) {
    Toast({
      message: `${error?.response?.data?.errorMessage}`,
      variant: 'error',
    });
    return error;
  }
};

export const AssociateTag = async (id, tagId, tagname) => {
  const requestedTag = {
    tagId,
    tagName: tagname,
  };
  try {
    return await Instance.post(`${API.ASSOCIATE_TAG}/${id}`, requestedTag);
  } catch (error) {
    Toast({
      message: `${error?.response?.data?.errorMessage}`,
      variant: 'error',
    });
    return error;
  }
};

export const FilterTag = async (tagId, documentStage, inputValue) => {
  const requestedTag = {
    tags: tagId,
    documentStage,
    searchData: inputValue,
  };
  try {
    const res = await Instance.post(`${API.SORT_ROW_DATA}`, requestedTag);
    if (res?.data?.documents.length === 0) {
      Toast({
        message: DOCUMENT_TOAST.NO_RECORDS,
        variant: 'warning',
        position: { vertical: 'top', horizontal: 'center' },
        autoHideDuration: 4000,
      });
      return res;
    }
    return res;
  } catch (error) {
    if (error?.response?.data?.errorMessage) {
      Toast({
        message: `${error?.response?.data?.errorMessage}`,
        variant: 'error',
      });
    }
  }
};

export const RemoveAssociateTag = async (id, tagId) => {
  const requestedTag = {
    tags: tagId,
  };
  try {
    return await Instance.post(
      `${API.REMOVE_ASSOCIATE_TAG}/${id}`,
      requestedTag,
    );
  } catch (error) {
    Toast({
      message: `${error?.response?.data?.errorMessage}`,
      variant: 'error',
    });
    return error;
  }
};

export const AssociateTagToAllDocuments = async (
  inputValue,
  filterModel,
  dropDownValue,
  tagId,
) => {
  const stageValue =
    dropDownValue &&
    Object.keys(dropDownValue).length > 0 &&
    dropDownValue.status.map((s) => s.status);
  const tagValue =
    dropDownValue &&
    Object.keys(dropDownValue).length > 0 &&
    dropDownValue.associatedTags.map((t) => t.id);
  const requestedTag = {
    stage: stageValue,
    searchData: inputValue,
    filterModel,
    tags: tagValue,
    associateTagId: tagId,
  };
  try {
    return await Instance.post(
      `${API.ASSOCIATE_TAG_TO_SELECTED_DOCUMENTS}`,
      requestedTag,
    );
  } catch (error) {
    if (error?.response?.data) {
      Toast({ message: `${error?.response?.data?.message}`, variant: 'error' });
    } else {
      Toast({ message: `${error?.message}`, variant: 'error' });
    }
  }
};

export const AssociateTagToSelectedDocuments = async (tagId, documentId) => {
  const requestedTag = {
    associateTagId: tagId,
    documents: documentId,
  };
  try {
    return await Instance.post(
      `${API.ASSOCIATE_TAG_TO_SELECTED_DOCUMENTS}`,
      requestedTag,
    );
  } catch (error) {
    if (error?.response?.data) {
      Toast({ message: `${error?.response?.data?.message}`, variant: 'error' });
    } else {
      Toast({ message: `${error?.message}`, variant: 'error' });
    }
  }
};

export const DeleteAssociateTagToSelectedDocuments = async (
  tagId,
  documentId,
) => {
  const requestedTag = {
    associateTagId: tagId,
    documents: documentId,
  };
  try {
    return await Instance.post(
      `${API.DELETE_ASSOCIATE_TAG_TO_SELECTED_DOCUMENTS}`,
      requestedTag,
    );
  } catch (error) {
    if (error?.response?.data) {
      Toast({ message: `${error?.response?.data?.message}`, variant: 'error' });
    } else {
      Toast({ message: `${error?.message}`, variant: 'error' });
    }
  }
};

export const gridFilterSortStatusForTagStage = async (gridKey, stage, tag) => {
  const data = {
    grid_key: gridKey,
    filter: { stage, tag },
  };
  try {
    return await Instance.post(`${API.INVOICE_COLUMN}`, data);
  } catch (error) {
    Toast({ message: `${error.message}`, variant: 'error' });
  }
};

export const renameTag = async (id, tagname) => {
  const requestedTag = {
    updatedTag: tagname,
  };
  try {
    return await Instance.patch(`${API.TAG_EDIT_DELETE}/${id}`, requestedTag);
  } catch (error) {
    Toast({ message: `${error?.response?.data?.message}`, variant: 'error' });
  }
};

export const deleteTag = async (id) => {
  try {
    return await Instance.delete(`${API.TAG_EDIT_DELETE}/${id}`);
  } catch (error) {
    Toast({ message: `${error?.response?.data?.message}`, variant: 'error' });
  }
};
